export const ACCESS_TOKEN = "access";
export const REFRESH_TOKEN = "refresh";

// reCAPTCHA Configuration
// For development - using test key provided by Google
// For production, replace with actual key from https://www.google.com/recaptcha/admin
export const RECAPTCHA_SITE_KEY = "6LeFtKMrAAAAAO1jT6jmdKRrUBKDDRAMVbGrqsjw";

// OAuth Configuration
// Get these from Google Cloud Console and Azure Portal
// Google: https://console.cloud.google.com/
// Microsoft: https://portal.azure.com/
// Uses environment variables in production, falls back to local dev values
export const GOOGLE_OAUTH_CLIENT_ID = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID || "1043048588981-rveuj4gufcfs70rtcriaqk74876fkgtv.apps.googleusercontent.com";
export const MICROSOFT_OAUTH_CLIENT_ID = import.meta.env.VITE_MICROSOFT_OAUTH_CLIENT_ID || "your_microsoft_client_id_here";